import { render, staticRenderFns } from "./AddExamPage.vue?vue&type=template&id=6316e991"
import script from "./AddExamPage.vue?vue&type=script&lang=js"
export * from "./AddExamPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports